import { render, staticRenderFns } from "./PermitNumberDialog.vue?vue&type=template&id=67e52564&"
import script from "./PermitNumberDialog.vue?vue&type=script&lang=js&"
export * from "./PermitNumberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports